<template>
  <m-geo-box geo-option="radius">
    <m-map-radius selectedType="quantity"></m-map-radius>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MMapRadius from '@/components/geo/MMapRadius'

  export default {
    components: {
      MGeoBox,
      MMapRadius
    },
    data () {
      return {
      }
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
    mounted () {
    }
  }
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/order/GeoRadiusClosX.vue